// js
import Vue from 'vue';
import BootstrapVue from '@delmar/bootstrap-vue';
import App from './App.vue';
import router from './router';
import Loader from './components/Loader.vue';
import ConfirmDialog from './plugins/confirm-dialog/confirm-dialog';
import { UserRootData } from './services/user-session';
import './icons';
import './directives/table-lines';
import './directives/select-on-click';

// css
import './assets/scss/phenix.scss';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(ConfirmDialog);
Vue.component('Loader', Loader);

new Vue({
  router,
  render: h => h(App),
  data: Object.assign(
    {
      warningMsg: '',
      toggleWarning: false,
    },
    UserRootData,
  ),
}).$mount('#app');
